export enum CognitoUserStatus {
  FORCE_CHANGE_PASSWORD = 'Force change password',
  PENDING_CONFIRMATION = 'Pending confirmation',
  CONFIRMED = 'Confirmed',
}